module.exports = __webpack_public_path__ + "12e5675ef35f1527d7f7b2842c315892.svg";